<template>
  <f7-page>
    <div style="padding:15px">
      <payment-lmsg></payment-lmsg>
    </div>
  </f7-page>
</template>

<script>
import PaymentLMSG from '@/pages/requests/components/PaymentLMSG.vue'

export default {
  name: 'PaymentFromApplicationForm',
  components: {
    'payment-lmsg': PaymentLMSG
  }
}
</script>



// WEBPACK FOOTER //
// PaymentFromApplicationForm.vue?c23760c0